export default __webpack_public_path__ + "static/media/фото-36.8682cbb4.jpg";